var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a;
import React from 'react';
import { ThreadWrapper, TimeWrapper, MessageWrapper, SecondRowWrapper, FirstRowWrapper, TitleWrapper, UnreadCountWrapper, } from './style';
import { Brand, getBrandFromHostname } from '@lendi/lala-utils';
import { joinNames } from './joinNames';
import { timeDifference } from './timeDiff';
var brandTitle = (_a = {},
    _a[Brand.Lendi] = 'Lendi',
    _a[Brand.Aussie] = 'Aussie',
    _a[Brand.Domain] = 'Domain Home Loans',
    _a);
export var Thread = function (_a) {
    var userGroup = _a.userGroup, names = _a.names, highlighted = _a.highlighted, lastMessage = _a.lastMessage, lastMessageDatetimeUTC = _a.lastMessageDatetimeUTC, UnreadMessageCount = _a.UnreadMessageCount, onSelected = _a.onSelected;
    var brand = brandTitle[getBrandFromHostname()];
    return (React.createElement(ThreadWrapper, { highlighted: highlighted !== null && highlighted !== void 0 ? highlighted : false, onClick: function () { return onSelected(userGroup); } },
        React.createElement(FirstRowWrapper, null,
            React.createElement(TitleWrapper, { className: "threadTitle", boldTitle: UnreadMessageCount > 0 }, joinNames(__spreadArray(__spreadArray([], names, true), [brand], false))),
            React.createElement(TimeWrapper, null, lastMessageDatetimeUTC ? timeDifference(new Date(), new Date(lastMessageDatetimeUTC)) : '')),
        React.createElement(SecondRowWrapper, null,
            React.createElement(MessageWrapper, null, lastMessage.length > 30 ? lastMessage.slice(0, 30) + '...' : lastMessage),
            UnreadMessageCount > 0 && React.createElement(UnreadCountWrapper, null, UnreadMessageCount))));
};
//# sourceMappingURL=index.js.map